import { render, staticRenderFns } from "./possessiva-pronomen.vue?vue&type=template&id=05fefe0a&scoped=true"
import script from "./possessiva-pronomen.vue?vue&type=script&lang=js"
export * from "./possessiva-pronomen.vue?vue&type=script&lang=js"
import style0 from "./possessiva-pronomen.vue?vue&type=style&index=0&id=05fefe0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fefe0a",
  null
  
)

export default component.exports